import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type MenuItem = {
  CrudName: string
  Id: string
  IsActive: boolean
  MenuLevel: number
  Description: string
  MenuSequence: number
  OpenNewPage: boolean
  Children: MenuItem[]
  ParentId: string | null
}

type MenuStore = {
  resetMenu: () => void
  items: MenuItem[]
  collapsed: boolean
  setMenuState: () => void
  setItems: (items: MenuItem[]) => void
}

export const useMenuStore = create<MenuStore>()(
  persist(
    (set) => ({
      items: [],
      collapsed: false,
      resetMenu: () => set(() => ({ items: [] })),
      setItems: (list: MenuItem[]) => set(() => ({ items: list })),
      setMenuState: () => set((state) => ({ collapsed: !state.collapsed })),
    }),
    {
      name: 'menu-storage',
      storage: encryptedStorage(),
    }
  )
)
